const defaultWidth = 28;
const defaultHeight = 28;

const IFPathIcon = ({ width = defaultWidth, height = defaultHeight }: SvgProps) => {
  return (
    <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9742 15.0077C19.3843 14.5977 20.0491 14.5977 20.4591 15.0077L23.9591 18.5077C24.3692 18.9178 24.3692 19.5826 23.9591 19.9927L20.4591 23.4927C20.0491 23.9027 19.3843 23.9027 18.9742 23.4927C18.5642 23.0826 18.5642 22.4178 18.9742 22.0077L20.6817 20.3002L4.55 20.3002C3.9701 20.3002 3.5 19.8301 3.5 19.2502C3.5 18.6703 3.9701 18.2002 4.55 18.2002L20.6817 18.2002L18.9742 16.4927C18.5642 16.0826 18.5642 15.4178 18.9742 15.0077Z"
        fill="#6A737D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.02579 4.50773C8.61574 4.09768 7.95092 4.09768 7.54087 4.50773L4.04087 8.00773C3.63082 8.41778 3.63082 9.08261 4.04087 9.49266L7.54087 12.9927C7.95092 13.4027 8.61574 13.4027 9.02579 12.9927C9.43585 12.5826 9.43585 11.9178 9.02579 11.5077L7.31826 9.8002L23.45 9.8002C24.0299 9.8002 24.5 9.3301 24.5 8.7502C24.5 8.1703 24.0299 7.7002 23.45 7.7002L15.3841 7.7002L7.31826 7.7002L9.02579 5.99266C9.43585 5.58261 9.43585 4.91778 9.02579 4.50773Z"
        fill="#6A737D"
      />
    </svg>
  );
};

export default IFPathIcon;
